import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/home";
import Information from "./components/information";
import Geography from "./components/geography";
import Biology from "./components/biology";
import Chemistry from "./components/chemistry";
import Physics from "./components/physics";
import Technology from "./components/technology";
import Mathematics from "./components/mathematics";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                {/*<Route path="/" element={<></>} />*/}
                <Route path="/welcome" element={<Home />} />
                <Route path="/information" element={<Information />} />
                <Route path="/technology" element={<Technology />} />
                <Route path="/physics" element={<Physics />} />
                <Route path="/chemistry" element={<Chemistry />} />
                <Route path="/biology" element={<Biology />} />
                <Route path="/geography" element={<Geography />} />
                <Route path="/mathematics" element={<Mathematics />} />
                <Route path="/*" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
